import { mainApi } from "services/main";
import {
  IContactRequest,
  IContactResponse,
  IEditContactRequest,
  IEditContactResponse,
  IGetContactRequest,
  IGetContactResponse,
  IGetAssociatedObjectsRequest,
  IGetAssociatedObjectsResponse,
  IUpdateObjectAssociationRequest,
  IUpdateObjectAssociationResponse,
} from "./definitions";

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    createContact: builder.mutation<IContactResponse, IContactRequest>({
      query: (request: IContactRequest) => ({
        url: "contact",
        body: request,
        method: "POST",
      }),
    }),
    editContact: builder.mutation<IEditContactResponse, IEditContactRequest>({
      query: (request: IEditContactRequest) => ({
        url: `/contact/${request.contactId}`,
        body: request,
        method: "PUT",
      }),
    }),
    getContact: builder.query<IGetContactResponse, IGetContactRequest>({
      query: (request: IGetContactRequest) => ({
        url: `/contact/${request.contactId}`,
        params: { teamName: request.teamName },
      }),
    }),
    getAssociatedObjects: builder.query<
      IGetAssociatedObjectsResponse,
      IGetAssociatedObjectsRequest
    >({
      query: (request) => ({
        url: `/associatedObjects/${request.parentObjectId}`,
      }),
    }),
    updateObjectAssociation: builder.mutation<
      IUpdateObjectAssociationResponse,
      IUpdateObjectAssociationRequest
    >({
      query: (request) => ({
        url: "/object-associations",
        method: "POST",
        body: request,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateContactMutation,
  useGetContactQuery,
  useEditContactMutation,
  useGetAssociatedObjectsQuery,
  useUpdateObjectAssociationMutation,
  usePrefetch,
} = extendedApi;
